import { callWithNuxt } from '#app';

export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp();
  const runTimeConfig = useRuntimeConfig();
  const dash = useDashboardStore();
  const AddAnnounceStore = useAddAnnounceStore();
  const queryId = Array.isArray(to.query.id) ? to.query.id[0] : to.query.id;
  const announcementId = Number(queryId);

  if (process.client) {
    if (!dash.getIsUserConnected) {
      await dash.fetchUserByToken();
    }
    const userCredits = Number(dash.getUserProfil.freeCredits || 0) + Number(dash.getUserProfil.additionalCredits || 0);

    // If the user doesn't have the required credits to create an announcement, redirect them
    if (!to.path.toLocaleLowerCase().includes('edit') && 
        to.path.toLocaleLowerCase().startsWith('/listing-form') && 
        userCredits < Number(runTimeConfig.public.newAnnouncementCredits)) {
      return callWithNuxt(nuxtApp, navigateTo, ['/dashboard/parameter/abonnement_et_transaction']);
    } else if (queryId) {
      if (!Number.isInteger(announcementId) || announcementId <= 0) {
        return callWithNuxt(nuxtApp, navigateTo, ['/dashboard/items']);
      }

      // Always refresh editable data for a deterministic first load.
      try {
        await AddAnnounceStore.announceEdit(announcementId);
        await AddAnnounceStore.fetchEditableById(String(announcementId));
      } catch (error) {
        AddAnnounceStore.resetEditableAnnounceValue();
        return callWithNuxt(nuxtApp, navigateTo, ['/dashboard/items']);
      }

      // If the announcement has a status of EXPIRED or ARCHIVED, redirect
      if (AddAnnounceStore.editabledAnnounce?.status?.includes('EXPIRED') || 
          AddAnnounceStore.editabledAnnounce?.status?.includes('ARCHIVED')) {
        return callWithNuxt(nuxtApp, navigateTo, ['/error']);
      }
      // If the connected user is not the owner of the announcement, redirect
      else if (AddAnnounceStore.editabledAnnounce?.userId !== dash.getUserProfil.id) {
        return callWithNuxt(nuxtApp, navigateTo, ['/error']);
      }
    }
  }
});
